module.exports = __webpack_public_path__ + "img/accompagnements.b971b606.png";